export default "__VITE_ASSET__CuHK1QEF__"